export default function searchForKeyInObject (keyToSearch, objectToSearch, result = []) {
  Object.keys(objectToSearch).forEach((key) => {
    if (key === keyToSearch) {
      result.push(objectToSearch[key])
      return result
    }
    if (objectToSearch[key] != null && typeof objectToSearch[key] === 'object') {
      searchForKeyInObject(keyToSearch, objectToSearch[key], result)
    }
  })
  return result
}
